export type Language = 'se' | 'en' | 'es';

export type TranslatedString = {
  id: string;
  se: string;
  en: string;
  no?: string;
};

export type i18nProps = (obj?: TranslatedString | null | string, ...params: string[]) => string;

export type useI18nProps = () => {
  i18n: i18nProps;
  language: Language;
  validate: (key: string) => boolean;
};

export interface Theme {
  main: string;
  secondary: string;
  contrastingColor: string;
  priceColor: string;
  entryBackground: string;
  menuBackgroundColor: string;
  menuTextColor: string;
}

export enum CURRENCY {
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  NOK = 'NOK',
  SEK = 'SEK',
  USD = 'USD',
}
